import { Box, Tag, useToggle } from '@factorialco/deprecated-design-system'
import { TrainingsSessionAttendanceStatusEnum } from 'generated/resources/graphql'

import PopoverMenu from 'modules/core/components/PopoverMenu'
import { handleResult } from 'modules/core/lib/handleMutation'
import i18n from 'modules/core/lib/i18n'
import app from 'modules/core/store/models/app'

import { useUpdateSessionAttendances } from 'modules/trainings/hooks/SessionAttendance/useUpdateSessionAttendances'

interface Props {
  status: TrainingsSessionAttendanceStatusEnum
  sessionId: number
  disabledAttendanceMenu?: boolean
}

const getTranslation = (status: TrainingsSessionAttendanceStatusEnum) => {
  switch (status) {
    case 'pending':
      return i18n.t('trainings.session_access_membership_table.not_started')
    case 'completed':
      return i18n.t('trainings.session_access_membership_table.completed')
    case 'missing':
      return i18n.t('trainings.session_access_membership_table.absent')
    case 'inprogress':
      return i18n.t('trainings.session_access_membership_table.started')
    default:
      throw new Error('Invalid status')
  }
}

const getColor = (status: TrainingsSessionAttendanceStatusEnum) => {
  switch (status) {
    case 'pending':
      return 'champagne'
    case 'completed':
      return 'viridian'
    case 'missing':
      return 'radical'
    case 'inprogress':
      return 'neutral'
    default:
      throw new Error('Invalid status')
  }
}

type PopoverOption = {
  label: string
  value: TrainingsSessionAttendanceStatusEnum
}

export const AttendanceTagWithMenu = ({
  status,
  sessionId,
  disabledAttendanceMenu = true,
}: Props) => {
  const [open, toggle] = useToggle()
  const { updateSessionAttendances } = useUpdateSessionAttendances()
  const onSubmit = async (status: TrainingsSessionAttendanceStatusEnum) => {
    const result = await updateSessionAttendances({
      ids: [sessionId],
      status: status,
    })

    const handled = handleResult(result, () => {
      app.setFlash({
        type: 'wrong',
        message: i18n.t('trainings.trainings_detail.training_details_updated'),
      })

      return
    })

    if (handled.success) {
      app.setFlash({
        type: 'correct',
        message: i18n.t('trainings.trainings_detail.training_details_updated'),
      })
    }
    toggle(false)()
    return handled
  }

  const sessionAttendanceStatus: PopoverOption[] = [
    {
      value: 'pending',
      label: i18n.t('trainings.session_access_membership_table.not_started'),
    },
    {
      value: 'missing',
      label: i18n.t('trainings.session_access_membership_table.absent'),
    },
    {
      value: 'completed',
      label: i18n.t('trainings.session_access_membership_table.completed'),
    },
  ]
  return (
    <Box>
      <PopoverMenu type="list" open={open} onClick={toggle(!open)}>
        <PopoverMenu.Trigger disabled={disabledAttendanceMenu}>
          <Box width="fit-content">
            <Tag
              leftItem="circle"
              showCircle
              showActionIcon={!disabledAttendanceMenu}
              rightItem="dropdown"
              type={getColor(status)}
            >
              {getTranslation(status)}
            </Tag>
          </Box>
        </PopoverMenu.Trigger>
        <PopoverMenu.Content side="bottom" align="end">
          {sessionAttendanceStatus.map((sessionStatus) => {
            return (
              <PopoverMenu.TouchableOption
                title={sessionStatus.label}
                onClick={() => onSubmit(sessionStatus.value)}
                key={sessionStatus.value}
              />
            )
          })}
        </PopoverMenu.Content>
      </PopoverMenu>
    </Box>
  )
}
